import { Box } from '@mui/material';
import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, BarChart, Bar, Tooltip } from 'recharts';
import { TenureDistributionChart } from 'domain/shared/staffing';
import { CustomTooltip } from './employeeTenureHelpers';
import { Alert } from 'framework/ui/mui-builder';

const EmployeeTenureChart = ({ data = [] }: { data: TenureDistributionChart[] }) => {
  if (!data?.length) {
    return <Alert color="info">No data</Alert>;
  }

  return (
    <Box sx={{ height: 400 }}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          margin={{
            top: 25,
            bottom: 10,
            right: 7,
          }}
        >
          <CartesianGrid strokeDasharray="2 2" />
          <XAxis
            dataKey="durationRange"
            height={80}
            padding={{ left: 5, right: 5 }}
            tick={{ fontSize: 12 }}
            label={{
              value: 'Tenure Duration (months)',
              position: 'insideBottom',
              offset: 10,
              style: { textAnchor: 'middle' },
            }}
          />
          <YAxis
            tick={{ fontSize: 12 }}
            label={{
              value: 'Number of Workers',
              angle: -90,
              offset: 10,
              position: 'insideLeft',
              style: { textAnchor: 'middle' },
            }}
          />

          <Tooltip content={<CustomTooltip />} />

          <Bar
            type="monotone"
            dataKey="employeeCount"
            name="Number of Workers"
            stroke="var(--mui-palette-text-primary)"
            strokeWidth={1}
            maxBarSize={60}
            fill="var(--mui-palette-warning-main)"
            label={{
              position: 'center',
              formatter: (value: number) => (!value ? '' : value),
              color: 'var(--mui-palette-text-primary)',
              style: {
                textAnchor: 'middle',
                fill: 'var(--mui-palette-text-primary)',
                color: 'var(--mui-palette-text-primary)',
              },
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default EmployeeTenureChart;
